import {
  Box,
  Checkbox,
  Radio,
  SxProps,
  Theme,
  Typography
} from "@mui/material";
import { InputType } from "../API";
import { AnswerOption } from "../features/AssessmentEvents/assessmentEventsAPI";

type AnswerOptionCardProps = {
  answerOption: AnswerOption;
  selected: boolean;
  inputType: InputType;
  onClick: () => void;
};

export const AnswerOptionCard = ({
  answerOption,
  selected,
  inputType,
  onClick
}: AnswerOptionCardProps) => {
  const styling: SxProps<Theme> = {
    display: "flex",
    gap: 2,
    alignItems: "center",
    borderRadius: "10px",
    padding: 2,
    border: "3px solid",
    borderColor: "#0000001F",
    cursor: "pointer"
  };

  if (selected) {
    styling.borderColor = "primary.main";
  }
  return (
    <Box sx={styling} onClick={onClick}>
      <Box>
        {inputType === InputType.Radio && (
          <Radio checked={selected} name="radio-buttons" />
        )}
        {inputType === InputType.Checkbox && (
          <Checkbox checked={selected} name="checkbox-buttons" />
        )}
      </Box>
      <Box>
        <Typography>{answerOption.anchor}</Typography>
        {answerOption.helpText && (
          <Typography
            color={"#00000099"}
            dangerouslySetInnerHTML={{ __html: answerOption.helpText }}
          />
        )}
      </Box>
    </Box>
  );
};
